import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../../../utils/page";

import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import store from "../../../../../store/index";
import { reactive, toRaw } from "vue";
import {
    createColumns,
    createFieldForCountryStandardGroup
} from "./country-standard-group.form";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../../i18n";
import { validateError } from "../../../../../utils/validate";
import { has } from "../../../../../utils/menu-context";
import {
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../../utils/button";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { Col, Modal, Row } from "ant-design-vue";
import { getLabTypeByAttribute } from "../lab-share.logic";
import { createRules, createForm } from "./country-standard-group.form";

export const actionPrefix = "resource/v1/master/labCountryStandardGroup";
export const routerPrefix = "country-standard-groups";

export const { isLoading, setIsLoading } = createLoading();

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, {
    id,
    config: { params: { isHardDelete: true } }
});
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callLabTypeByKey = ({ key }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
    group: "LAB_TYPE",
    key
});
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, {
    ids,
    config: { params: { isHardDelete: true } }
});
export const findDefault = ({ id, labTypeId, productTypeId }) => store.dispatch(`${actionPrefix}/findDefault`, { id, labTypeId, productTypeId });

function getManages(menuContext) {
    return [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) => onClickActiveAll({
                rowSelection,
                callActiveAll,
                state,
                onSearch,
                setIsLoading
            })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) => onClickArchiveAll({
                rowSelection,
                callArchiveAll,
                state,
                onSearch,
                setIsLoading
            })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) => onClickDeleteAll({
                rowSelection,
                callDeleteAll,
                state,
                onSearch,
                setIsLoading
            })
        }),
        createManageExportCsv({ menuContext })
    ];
}

function getManageExtras(menuContext) {
    return [createManageExtraCreate({
        menuContext,
        onClick: () => onClickCreate({ routerPrefix })
    })];
}

export const initState = ({ props, data }) => {
    getLabTypeByAttribute({ props, data }).then(labType => {
        const menuContext = props.menuContext;
        state.manages = getManages(menuContext);
        state.manageExtras = getManageExtras(menuContext);
        state.rowActions = [
            createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
            createRowActionEdit({ menuContext, onClick: ({ record }) => onClickEdit({ record, routerPrefix }) })
        ];
        state.columns = createColumns({ labType });
    });
};

export const onSearch = ({ page }) => {
    setIsLoading(true);
    const where = page.where || [];
    window.onSearch?.({ page });
    return callSearch({
        criteria: {
            ...page,
            data: [],
            where: [...where]
        }
    }).then(page => state.page = { ...page, where }).catch(err => {
        console.error(err);
    }).finally(() => setIsLoading(false));

};

export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: ["**"],
            sort: [{ name: "isDefault", type: "DESC" }, { name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } }
});

function doLoadForm(props, data, refs) {
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({
                            props,
                            data,
                            refs,
                            state,
                            routerPrefix,
                            onClickView,
                            onClickEdit
                        }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        });
}

export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    getLabTypeByAttribute({ data, props }).then(resultData => {
        data.form = createForm();
        data.rules = createRules();
        data.useForm = createUseForm(data.form, data.rules);
        data.fields = createFieldForCountryStandardGroup({ props, data, resultData, refs, isLoading });
        doLoadForm(props, data, refs);
    });
};


export const createFormTitle = ({ data }) => {
    return data.useForm?.modelRef.id ? data.useForm.modelRef.name : i18n.global.t("button.create");
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly } = props;
    const { id, isActive } = data.useForm.modelRef;
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && has({ menuContext, key: "canEdit" })) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive))) {
        col1.push(createButtonSave({ onClick: () => onClickSave({ props, data, refs }), classStyle: "m-1" }));
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(createButtonActive({
            onClick: () => onClickActive({
                record: { id },
                callActive,
                setIsLoading: setIsLoadingApp,
                onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
            }), classStyle: "m-1"
        }));
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(createButtonArchive({
            onClick: () => onClickArchive({
                record: { id },
                callArchive,
                setIsLoading: setIsLoadingApp,
                onClickView: () => onClickView({ record: { id }, routerPrefix })
            }), classStyle: "m-1"
        }));
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canDelete" })) {
        col2.push(createButtonDelete({
            onClick: () => onClickDelete({
                record: { id },
                callDelete,
                setIsLoading: setIsLoadingApp,
                state,
                routerPrefix
            }), classStyle: "m-1"
        }));
    }
    return <Row type='flex'>
        <Col>{col1}</Col>
        <Col class='ml-auto'>{col2}</Col>
    </Row>;
};

function doSave(data) {
    return data.useForm
        .validate()
        .then(() => {
            data.useForm.modelRef.value = data.useForm.modelRef.key;
            setIsLoadingApp(true);
            return callSave({ form: data.useForm.modelRef })
                .finally(() => {
                    state.refProductType = data.useForm?.modelRef?.refProductType;
                    setIsLoadingApp(false);
                })
                .then((record) => onClickView({ record, routerPrefix }));
        }).catch((error) => {
            validateError({ error });
        }).finally(() => {
            setIsLoadingApp(false);
        });
}

export const onClickSave = ({ data }) => {
    const form = toRaw(data.useForm.modelRef);
    if (data.useForm.modelRef.isDefault) {
        findDefault({ id: form.id, labTypeId: form.refLabType.id, productTypeId: form.refProductType.id }).then(page => {
            const defaultResult = page.data[0];
            if (defaultResult) {
                const text = i18n.global.t("lab.countryStandardGroup.labels.changeDefault", {
                    before: defaultResult.name,
                    after: data.useForm.modelRef.name
                });
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        return doSave(data);
                    }
                });
            } else {
                return doSave(data);
            }
        });
    } else {
        return doSave(data);
    }
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => {
            data.useForm.modelRef.refProductType = state.refProductType || null;
            defaultLab({ props, data });
            initUseForm({ props, data, refs, page, routerPrefix });
        })
        .finally(() => setIsLoading(false));
};

export const defaultLab = ({ props, data }) => {
    const { menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    if (data.labAttributes.length > 1) {
        return true;
    }
    if (has({ menuContext, key: "labMicro" })) {
        callLabTypeByKey({ key: "labMicro" }).then(items => {
            modelRef.refLabType = items[0];
        });
    }
    if (has({ menuContext, key: "labPhysic" })) {
        callLabTypeByKey({ key: "labPhysic" }).then(items => {
            modelRef.refLabType = items[0];
        });
    }
    if (has({ menuContext, key: "labChemi" })) {
        callLabTypeByKey({ key: "labChemi" }).then(items => {
            modelRef.refLabType = items[0];
        });
    }
    return false;
};